import React from 'react'
import { isPresent } from 'ts-extras'
import { useTranslations } from '~/components/Locale'
import type { CurrencyCode, HTMLElementProps, Obj } from '~/types'
import { cn, getPrice, isMoneyV2, MoneyValue, numberFormatter } from '~/utils'

type Props = HTMLElementProps<'span'> & {
	price: Exclude<React.ReactNode, boolean | Obj> | MoneyValue
	original?: Exclude<React.ReactNode, boolean | Obj> | MoneyValue
	currencyCode?: CurrencyCode
	decimals?: number
	asText?: boolean
}

function isNum(n: any): n is number {
	return !isNaN(n)
}

// TODO: Check that locale swaps rerenders as expected
export const Price: React.FC<Props> = ({ price, original, decimals, asText = false, currencyCode, ...rest }) => {
	const free = useTranslations('react.checkout.free')
	const format = (n: typeof price) =>
		isMoneyV2(n)
			? getPrice(n, asText, decimals)
			: asText
			? getPrice(
					currencyCode && isPresent(n) ? { amount: n.toString(), currencyCode } : (n as number),
					true,
					decimals
			  )
			: isNum(n)
			? numberFormatter().format(n)
			: n
	const discounted = original !== price && (typeof original === 'number' ? original > 0 : !!original)
	return (
		<span {...rest}>
			{discounted && (
				<>
					<s className="whitespace-nowrap text-gray-400">{format(original)}</s>
					<span>&nbsp;</span>
				</>
			)}
			<span className={cn('whitespace-nowrap', { green: discounted })}>
				{price === 0 && asText && free ? free : format(price)}
			</span>
		</span>
	)
}
